import {
  loadStoredEditorValue,
  saveStoredEditorValue,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

const withGeneratedId = entry => ({ ...entry, id: crypto.randomUUID() })

export const createScenarioEntry = collection => withGeneratedId(collection.newEntry)

const getDefaultScenarioEntries = collection => collection.defaultEntries.map(withGeneratedId)

export const loadScenarioEntries = (collection, storeId) => {
  return loadStoredEditorValue(collection.storageKeyPrefix, storeId) ?? getDefaultScenarioEntries(collection)
}

export const saveScenarioEntries = (collection, storeId, entries) => {
  saveStoredEditorValue(collection.storageKeyPrefix, storeId, entries)
}

export const updateScenarioEntry = (entries, entryId, changes) => {
  return entries.map(entry => (entry.id === entryId ? { ...entry, ...changes } : entry))
}

export const removeScenarioEntry = (entries, entryId) => entries.filter(entry => entry.id !== entryId)
